'use client';
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from 'next/router';

import ClientComponent from '@/components/builder/client_component';
import { getGoogleCredentialsFromLS } from '@/load_and_get_google_access_token';
import DTag from '../../dynamic_tag';
import QuestionComponent from "../quesition";
import MultiImageCarousalMultiSelection from '../components/multi_image_carousal_multi_selection';
import VerticalSingleSelection from '../components/vertical_single_selection';
import VerticalMultiSelection from '../components/vertical_multi_selection';
import FileUpload from '../components/file_upload';
import TextAreaChoice from '../components/text_area';
import PopUpComponent from '../components/popup';
import QuestionIndicator from '../components/question_indicator';
import ColorPalleteSingleSelection from '../components/color_pallete_single_selection';
import HorizontalBudgetSingleSelection from '../components/budget_single_selection';
import UploadYourHomeInstructions from '../components/upload_your_home_instructions';

import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Alert, CircularProgress, LinearProgress, Menu, MenuItem, Paper, Skeleton } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { GetOnboardinData, saveCustomerStyleProfile } from '@/store/questionniareSlice';
import cssStyles from './questions.module.scss';
import tabStyles from './tabs.module.scss';
import { DeviceDetector, getLoggedInEmailAddress, getLoggedInName, gtmClickTracking, gtmPageOnloadTracking, navigateWithHistory } from '@/utils';
import { getCurrentBrand, getCustIdFromLS, getCustStyleProfileIdFromLS, getEitherCustIdFromLs, getUserInfo, setTempCustIdToLS } from '@/utils/useUserInfo';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Layer from '@/components/layer';
import dynamic from 'next/dynamic';
import { title } from 'process';

import { userInfo } from 'os';

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface Section {
  title: string;
  sectionID: string;
  count: number;
  sequences: Array<number>;
}

export interface Choice {
  recommended: string;
  choiceid: string;
  choice: string;
  image?: string;
}

export interface ChoiceAnswer {
  choiceid: string;
  answer: string;
}
export interface EditDataResponseAnswer {
  answers: Array<ChoiceAnswer>
}
export interface editData {
  responses: Array<EditDataResponseAnswer>
  customerID: string;
  sectionID: string;
  questionID: string;
}

export interface currentTab {
  index: number;
  currentSection: any;
}


export interface currentQuestionnaireInfo {
  questionSequence: number;
  previousQuestionSequence: number;
  selectedAnswerValueChanged: boolean;//used for comparision of answers
  sectionID: string;
  nextSectionID: string;
  firstQuestionNumber: string;//used only once when changed to nextSection first question
  noOfQuestionsCount: number;
  questionID: string;
}

export interface SelectionData {
  selectedAnswer?: Array<ChoiceAnswer>;
  setSelectedAnswer: Function;
  shortQuestion: string;
  choices: Array<Choice> | any;
  editData: editData;
  isBudgetFlow: string;
  label?: string;
  props: any;
}

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}




export const Limit = 12;
export const ImageLimit = 6;
export const ColorLimit = 20;

let isStyleQuizFirstScreen = false;


function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box component="div" sx={{ mt: '20px' }}>
          <Typography component={'div'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


function RoomConfirmationOverlay({ heading, onClose, onConfirmClick }: any) {
  return (<>
    <Box component="div" sx={{
      padding: '20px 15px',
      textAlign: 'center'
    }}><strong>{heading}</strong></Box>

    {/* <Button onClick={onClose} sx={{
      backgroundColor: 'primary.light',
      '&:hover': {
        backgroundColor: 'primary.light'
      },
      borderColor: 'primary.main'
    }}>
      Cancel
    </Button>
    <Button onClick={onConfirmClick} sx={{
      backgroundColor: 'primary.light',
      '&:hover': {
        backgroundColor: 'primary.light'
      },
      borderColor: 'primary.main'
    }}>
      Go
    </Button> */}
  </>)
}

function FuzzyDropdown({
  customerRoomLabelResponse,
  roomLabel,
  roomType,
  setRoomLabel,
  customerID
}: any) {
  const [filteredData, setFilteredData] = useState<any>([]);
  const navigateURL = useRef('');
  const userInputValue = useRef('');
  const [dValue, setDefaultValue] = useState<any>({ "roomLabel": roomLabel == `${getLoggedInName()}'s ${(roomType == "null" || roomType.indexOf("Not")) > -1 ? "Room" : roomType}` ? "" : roomLabel });

  const [showOverlay, setShowOverlay] = useState<any>(false);
  const timer = useRef<any>();

  useEffect(() => {
    if (roomType && roomType.length > 0 && customerRoomLabelResponse) {
      const roomLableResponseArr = customerRoomLabelResponse.filter((item: any) => {
        return item.roomLabel && roomType == item.roomType;
      })
      setFilteredData(roomLableResponseArr)
    }
  }, [roomType, customerRoomLabelResponse])

  const handleInputChange = (event: any, value: any) => {
    const inputValue = value.trim().replace(/\<\>\:/g, '');
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (!event || !inputValue) {
        return;
      }
      if (customerRoomLabelResponse?.find((eachRoom: any) => eachRoom.roomLabel === inputValue)) {
        setShowOverlay(true);
        userInputValue.current = inputValue;
        navigateURL.current = `${getCurrentBrand()}/recommendations/${encodeURIComponent(roomType)}`;
        return;
      }

      const defaultValue = {
        "roomLabel": inputValue,
        "CustomerID": customerID,
        "roomType": roomType
      }
      setRoomLabel(inputValue);
      setDefaultValue(defaultValue);
    }, 500);

  }

  //used for default value setting on load
  const isOptionEqualToValue = (option: any, value: any) => {
    return option.roomLabel === value;
  };

  if (!roomType || roomType.length <= 0) {
    return <></>;
  }

  const onClose = () => {
    setDefaultValue({ "roomLabel": "" });
    setShowOverlay(false);
  }

  const onConfirmClick = () => {
    navigateWithHistory(navigator, navigateURL.current)
  }

  return (<div>
    <Typography sx={{ marginTop: "40px" }} className="" variant="h3" color="inherit" text-transform="none" noWrap>Let’s name your {(roomType == "null" || roomType.indexOf("Not")) > -1 ? "room" : roomType}</Typography>
    <Autocomplete
      sx={{ margin: "20px 0" }}
      options={filteredData}
      getOptionLabel={(option: any) => option.roomLabel}
      value={dValue}
      renderInput={(params) => (
        <TextField {...params}
          label={`My ${(roomType == "null" || roomType.indexOf("Not")) > -1 ? "favorite room" : roomType}`}
          variant="standard"
        />)}
      isOptionEqualToValue={isOptionEqualToValue}
      onInputChange={handleInputChange}
    />
    {
      (showOverlay) ?
        <Layer
          open={showOverlay}
          onClose={onClose}
          Element={RoomConfirmationOverlay}
          dialogContentClassName={''}
          dialogContentComponentProps={{
            heading: 'Looks like a room with the same name already exists, please provide a different name to continue.',
            onClose,
            onConfirmClick
          }}
          dialogTitle={''} /> : <></>
    }
  </div>
  );
}


export const getQuestionType = (type = "", questionId = "", template: any) => {

  const questionData = {
    Element: VerticalSingleSelection,
    props: { template, imageIrregularView: false, imageGridMultiSelection: false, paintPreferences: false, isBudgetFlow: false, isPersonality: false, colorPallete: false, styleQPref: false }
  }
  //TODO need to remove hardcoding for What is a must have item? question
  if (questionId === "2b02ec00-49be-43f3-84b1-13c0a8e5473e") {
    type = "multi_selection_image_grid"
  }
  switch (type) {

    case "vertical_single_selection":
      questionData.Element = VerticalSingleSelection;
      break;
    case "vertical_multi_selection":
      questionData.Element = VerticalMultiSelection;
      break;
    case "get_back_to_you_paint":
      questionData.Element = VerticalSingleSelection;
      questionData.props.paintPreferences = true;
      break;
    case "multi_selection_image_grid_style":
      questionData.Element = VerticalMultiSelection;
      questionData.props.imageGridMultiSelection = true;
      questionData.props.styleQPref = true;
      break;
    case "multi_selection_image_grid_personality":
      questionData.Element = VerticalMultiSelection;
      questionData.props.isPersonality = true;
      break;
    case "multi_selection_image_grid":
      questionData.Element = VerticalMultiSelection;
      questionData.props.imageGridMultiSelection = true;

      if (questionId === "25c19941-7f68-4528-91e0-74108284fbae") {
        questionData.props.styleQPref = true;
      }

      break;
    case "multi_selection_image_grid_irregular":
      questionData.Element = VerticalMultiSelection;
      questionData.props.imageIrregularView = true;
      questionData.props.imageGridMultiSelection = true;

      if (questionId === "25c19941-7f68-4528-91e0-74108284fbae") {
        questionData.props.styleQPref = true;
      }

      break;
    case "file_upload": questionData.Element = FileUpload; break;
    case "multi_question_multiselection_image_grid": questionData.Element = MultiImageCarousalMultiSelection;
      if (questionId === "0cae347b-add7-41ea-b923-a2bb6666b31f") {
        questionData.props.styleQPref = true;
      }
      break;
    case "color_pallete_single_selection": questionData.Element = ColorPalleteSingleSelection; break;
    case "text_area": questionData.Element = TextAreaChoice; break;
    case "horizontal_budget_single_selection":
      questionData.Element = HorizontalBudgetSingleSelection;
      questionData.props.isBudgetFlow = true; break;
    case "upload_your_home_instructions": questionData.Element = UploadYourHomeInstructions; break;
    case "multi_question_multiselection_image_grid_lighting":
      questionData.Element = MultiImageCarousalMultiSelection;
      break;
    case "multi_question_multiselection_image_grid_personality":
      questionData.Element = MultiImageCarousalMultiSelection;
      questionData.props.styleQPref = true;
      questionData.props.isPersonality = true;
      break;

    case "multi_selection_image_grid_group_by_subtext":
      questionData.Element = MultiImageCarousalMultiSelection;
      questionData.props.styleQPref = true;
      questionData.props.isPersonality = false;
      break;
  };
  return questionData;
}

const navigateWithOutPreviousHistory = (router: any, path: any) => {
  router.push(path, undefined, { shallow: true, replace: true });
};

const BasicTabs = (props: any) => {
  let { customerType = "DefaultCustomer", brand, isHideRoomTypeQuestion, roomType, roomId: roomIdParam, rl } = props;
  console.log("BasicTabs: roomType : ", roomType, " roomId : ", roomIdParam, " customerType : ", customerType, 'rl: ', rl, 'isHideRoomTypeQuestion:', isHideRoomTypeQuestion);
  const [updateDOM, setUpdateDOM] = useState(new Date().getMilliseconds());
  const [selectedAnswer, setSelectedAnswer] = useState<ChoiceAnswer[]>([]);//only in case of next button fresh click
  const [showError, setShowError] = useState(false);

  const navigate = useRouter();

  const deviceTypeModel = DeviceDetector() as any;

  const isRoomQuiz = window.location.pathname.indexOf("/roomquiz") >= 0 ? true : false;

  const isNextButtonClicked = useRef(false);
  const triggerSectionsCall = useRef(false);
  const [roomTypeFromQuestion, setRoomTypeFromQuestion] = useState<any>();
  const [roomLabel, setRoomLabel] = useState<string>((rl && rl.length > 0) ? rl.replace(/[<>:*]/g, '') : `${getLoggedInName()}'s ${(roomType == "null" || roomType.indexOf("Not")) > -1 ? "Room" : roomType}`);
  const naviagtetoHome = useRef<boolean>(false);
  const navigatetoNextQuestion = useRef({ isMinSelQuestion: false, minSelections: 0 });
  const isdefaultCustAndProjectIdCalTriggered = useRef<boolean>(false);
  const [useExistingStyleProfile, setUseExistingStyleProfile] = useState<boolean | undefined>(undefined);
  const [askToUseExistingStyleProfile, setAskToUseExistingStyleProfile] = useState(false);
  const [isProfileLoaded, setProfileLoaded] = useState(false);
  const [hideLayerTitle, setHideLayerTitle] = useState(false);
  const [showDefaultCustomerStyleQuiz, setShowDefaultCustomerStyleQuiz] = useState(false);
  const [saveStyleSchemeSelectionApiCall, setSaveStyleSchemeSelectionForApiCall] = useState(false);
  const [selectedStyleScheme, setSelectedStyleScheme] = useState("");
  const [styleVibeImage, setStyleVibeImage] = useState("");
  const [styleProfileDesc, setStyleProfileDescription] = useState("");
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const env = process.env.NEXT_PUBLIC_APP_ENV === 'qa' ? 'qa' : 'prod';
  // const env='qa'
  

  useEffect(() => {   
      //edit flow and when clicked on help_me
      if(showDefaultCustomerStyleQuiz || getCustStyleProfileIdFromLS()){
          gtmPageOnloadTracking({
              event: 'stylequiz_started',
              pageType: "Style Questionnaire",
              brand: brand,
          });
      }
      if (!getCustStyleProfileIdFromLS() && !showDefaultCustomerStyleQuiz) {
        gtmPageOnloadTracking({
          pageType: "Style Questionnaire",
          pageName: "Preheat Style Selector",
          pageTitle : "Preheat: Select your Style",
          brandName: brand
        });
      }
  }, [showDefaultCustomerStyleQuiz]);

  // const responseData = useSelector(welcomePageData);
  const {
    resetState,
    getSectionsData,
    setCurrentQuestion,
    saveCustResponseReturnnExtQuestionData,
    postProfileData,
    roomTypesData,
    getRoomTypesData,
    customerID,
    profileData,
    roomId,
    sectionQuestion,
    navigateToProjectGoal,
    allQuestionsData,
    currentQuestionnaireInfo,
    pickCurrentSectionDetailsToState,
    isMinSelQuestion,
    currentTab,
    moveToLoginPage,
    resetMoveToLoginPage,
    sectionsInfoData,
    customerRoomLabelResponse,
    getCustomerRoomLabel,
    styleSchemesData,
    getStyleSchemes
  } = GetOnboardinData();

  useEffect(() => {
    //
    return () => {
      //resetState()
    }
  }, [selectedAnswer])

  useEffect(() => {
    if (!showDefaultCustomerStyleQuiz) {
      getStyleSchemes({ brand })
    }
  }, [])


  useEffect(() => {
    isRoomQuiz && getRoomTypesData({});
    postProfileData({
      firstName: getLoggedInName() || "Default Customer",
      email: getLoggedInEmailAddress() || undefined, //guest user we dont pass email
      customerID: getEitherCustIdFromLs() || undefined,
      includeStyleProfile: true,
      brand
    }) as any;
  }, [])

  useEffect(() => {
    if (profileData && profileData?.customerID) {
      setProfileLoaded(true);
      if (triggerSectionsCall.current == false) {
        if (isRoomQuiz && profileData?.styleProfileID && askToUseExistingStyleProfile == false&& profileData?.styleVibeImage) {
          setAskToUseExistingStyleProfile(true);
        } else {
          triggerSectionsCall.current = true
          getSectionsData({ customerType: customerType.replace(/[<>*]/g, ''), isHideRoomTypeQuestion, brand }) as any;
        }
      }
    }
  }, [profileData])

  useEffect(() => {
    if (useExistingStyleProfile === true || useExistingStyleProfile === false) {
      setAskToUseExistingStyleProfile(false);
      if (triggerSectionsCall.current == false) {
        triggerSectionsCall.current = true;
        getSectionsData({ customerType: customerType.replace(/[<>*]/g, ''), IsApplyStyleToRoom: ((profileData?.styleProfileID && useExistingStyleProfile) ? true : false), isHideRoomTypeQuestion, brand }) as any;
      }
    }
  }, [useExistingStyleProfile])



  useLayoutEffect(() => {
    if (sectionQuestion) {
      const currentQuestionnaireInfo = sectionQuestion.NextQuestionAnswerChoices;

      const stpRoomTypeSel = currentQuestionnaireInfo?.questions[0]?.choices.find((obj: Choice) => (obj.choice === roomType))
      if (stpRoomTypeSel && currentQuestionnaireInfo.shortQuestion === "Room") {
        setSelectedAnswer([stpRoomTypeSel]);
      } else {
        setSelectedAnswer([]);
      }
    }
  }, [sectionQuestion])

  useEffect(() => {
    if (navigateToProjectGoal && sectionQuestion) {
      navigateWithOutPreviousHistory(navigate, "/projectgoal")
    }
  }, [navigateToProjectGoal])


  const LoginLayer = dynamic(() => import('@/components/login'), {
    ssr: false,
  });

  const [openLogin, setOpenLogin] = React.useState<boolean>(false);
  const openLoginLayer = async () => {
    if (sectionQuestion?.NextQuestionAnswerChoices?.sectionType != 'RoomQuiz' && (!getLoggedInEmailAddress())) {
      setHideLayerTitle(true);
    }
    if(!getLoggedInEmailAddress()){
      setOpenLogin(true);
    }else{
      //if already logged in navigate to style profile
      await loginCallback()
    }
  };
  const closeLoginLayer = () => {
    setOpenLogin(false);
    if (sectionQuestion?.NextQuestionAnswerChoices?.sectionType != 'RoomQuiz' && (!getLoggedInEmailAddress())) {
      setHideLayerTitle(true);
    }
  };
  const loginCallback = async () => {
    document.body.style.display = "none";
    setLoading(true);
    console.log("loginCallback called");
    const emailAddress = getLoggedInEmailAddress();
    if (emailAddress && saveStyleSchemeSelectionApiCall) {
      closeLoginLayer();
      setLoading(true);
      // <div className={cssStyles["load-questions"]}><CircularProgress /></div>
      (async function () {
        try {
          gtmClickTracking({
          event: "preheat_style_selector",
          pageType: "Style Questionnaire",
          pageName: "Preheat Style Selector",
          pageTitle : "Preheat: Select your Style",
          brandName: brand,
          sq_style_selected: (selectedStyleScheme == null) ? "help_me" : selectedStyleScheme.replaceAll("_", " ")
        });
        await getUserInfo("",
          true,
          false,
          selectedStyleScheme);

        localStorage.setItem("sqc", "true");
        navigateWithHistory(navigate, `${getCurrentBrand()}/styleprofile`)
      } catch(error) {
        console.error("Error during login callback:", error);
      } finally {
        setLoading(false);
      }
      })();
    } else {
      // window.location.href = `${getCurrentBrand()}/styleprofile`
      navigateWithHistory(navigate, `${getCurrentBrand()}/styleprofile`)
      setLoading(false);
    }
  };

  useEffect(() => {
    if (moveToLoginPage) {
      try {
        //remove the style profile room type selection
        //localStorage.removeItem('stpRoomTypeSel');
      } catch (e) { }
      const custType = customerType.replace(/[<>*]/g, '') || "dc";

      if (window.location.pathname.indexOf("/roomquiz") > -1) {
        navigateWithHistory(navigate, `${getCurrentBrand()}/recommendations/${getRoomType(roomTypeFromQuestion) || roomType}/${roomId || roomIdParam}`)
      } else {
        //navigateWithOutPreviousHistory(navigate, `/login/${custType}`)
        //if(window.location.hostname.indexOf('qa.nestingale.com') > -1){
        openLoginLayer();
        //} else {
        //  window.location.href = `/login/${custType}`;
        //}
      }

    }
    return () => {
      {loading && (
        <div className={cssStyles["load-questions"]}>
          <CircularProgress />
          <h1>Loading.....</h1>
        </div>
      )}
      resetMoveToLoginPage();
    }
  }, [moveToLoginPage])


  useEffect(() => {
    //on questionData save to DB update the DOM and navigate to home if save and exit
    if (sectionQuestion) {
      setUpdateDOM(new Date().getMilliseconds());
    }
    if (naviagtetoHome.current) {
      navigateWithHistory(navigate, "/rooms");
    }
  }, [sectionQuestion])


  const saveAndExit = () => {
    naviagtetoHome.current = true;
    saveAndMoveNext(false, false, true);
  }
  const [fromFirstFlow,setFromFirstFlow]=useState(false)
  const goPreviousQuestion = () => {
    if(styleSchemesData && styleSchemesData.length > 0 && currentQuestionnaireInfo.questionSequence == 1) {
      return setShowDefaultCustomerStyleQuiz(false)
    }else if(currentQuestionnaireInfo.questionSequence == 3&&fromFirstFlow){
      setFromFirstFlow(false)
      setShowDefaultCustomerStyleQuiz(false)
    setCurrentQuestion({ previous: true} as any);
    setCurrentQuestion({ previous: true} as any);
    return
    }
    setCurrentQuestion({ previous: true} as any);
    window.scrollTo(0, 0);
  }


  const compareArrays = (a: any, b: any) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };


  const getTextForNumbers = (index: number) => {
    let answer = "Zero"
    switch (index) {
      case 1: answer = "one"; break;
      case 2: answer = "two"; break;
      case 3: answer = "three"; break;
    }
    return answer;
  }

  const getRoomType = (lable: string) => {
    if (!lable) return null;
    let matchedRooms = roomTypesData.filter((roomTypeData: { roomTypeDisplayName: string, roomType: string }) =>
      (roomTypeData.roomTypeDisplayName?.indexOf(lable) != -1 || roomTypeData.roomType?.indexOf(lable) != -1));
    return matchedRooms[0]?.roomType || decodeURIComponent(lable).replace(/[<>*]/g, '');
  }

  const getQuizFields = () => {
    if (isRoomQuiz) {
      return {
        "roomLabel": '',//to prevent it from room labelling. because we are labeling the room in create room plan section component
        "roomType": getRoomType(roomTypeFromQuestion || roomType),
        "roomId": roomId || roomIdParam,
        "isRoomQuizComplete": sectionQuestion && sectionQuestion.isLastQuestion && (sectionsInfoData.length <= currentTab.index + 1) ? true : false,
        "IsApplyStyleToRoom": (profileData?.styleProfileID && useExistingStyleProfile) ? true : false,
        "IsStyleQuizComplete": (profileData?.styleProfileID) ? true : false,
      }
    } else {
      return { "IsStyleQuizComplete": sectionQuestion && sectionQuestion.isLastQuestion && (sectionsInfoData.length <= currentTab.index + 1) ? true : false, }
    }
  }

  const saveAndMoveNext =(withEmptyResponses: boolean = false, buttonClick: boolean = false, isPopupContinue = false) => {
    setShowError(false);
      window.scrollTo(0, 0);
    //if we want to post for first question call with answer we must have customerID
    //if response is not yet come for customerId just return if user clicks on next button again
    if (isdefaultCustAndProjectIdCalTriggered.current && !profileData?.customerID) {
      return;
    }

    if (sectionQuestion && sectionQuestion.isLastQuestion && sectionsInfoData.length > currentTab.index + 1) {
      if (!isPopupContinue) {
        isNextButtonClicked.current = true;
        return setUpdateDOM(new Date().getMilliseconds());
      } else {
        //when continue button is clicked reset this flag
        isNextButtonClicked.current = false;
      }
    }

    let currentSection = sectionsInfoData[currentTab.index] as Section;

    let isEqual = false;
    try {
      isEqual = compareArrays(sectionQuestion.NextQuestionAnswerResponse?.responses[0].answers, selectedAnswer)

    } catch (e) {
      isEqual = false;
    }
    if (roomLabel.length <= 0 && selectedAnswer.length === 0 && sectionQuestion !== null && (sectionsInfoData.length > currentTab.index + 1)) {
      //setShowError(true);
      return;
    }

    //if question sequence is greater than Section->Sequence_Array then update to next section
    if (!pickCurrentSectionDetailsToState && currentSection.sequences.length <= currentQuestionnaireInfo.questionSequence && !isEqual
      && sectionQuestion != null /** only in case of pickNextSectionFirstQuestion, sectionQuestion is made null */ && sectionsInfoData.length > currentTab.index + 1) {
      setCurrentQuestion({ next: true, selectedAnswerValueChanged: isEqual, pickNextSectionFirstQuestion: true } as any)
    } else if (pickCurrentSectionDetailsToState || (currentQuestionnaireInfo.navigateToNextSectionUsingCache && isEqual) || allQuestionsData[currentSection.title] &&
      allQuestionsData[currentSection.title][currentQuestionnaireInfo.questionSequence] && isEqual && sectionsInfoData.length >= currentTab.index + 1) {
      setCurrentQuestion({ next: true, selectedAnswerValueChanged: isEqual } as any)
    } else {
      if (selectedAnswer) {
        if (roomLabel.length <= 0 && buttonClick && selectedAnswer.length === 0 && (sectionsInfoData.length > currentTab.index + 1)) {
          //setShowError(true);
          isNextButtonClicked.current = false;
          return;
        }
        if ((roomLabel.length <= 0 && selectedAnswer.length === 0 && currentQuestionnaireInfo.questionSequence > 0) || navigatetoNextQuestion.current.isMinSelQuestion && selectedAnswer.length < navigatetoNextQuestion.current.minSelections) {
          return;
        } else {
          resetState();
        }

        if (roomLabel.length <= 0 && (roomTypeFromQuestion || roomType) && customerType && sectionQuestion) {
          return;
        }
        //set an indicator that the customer completed their style quiz
        if (sectionQuestion && sectionQuestion.isLastQuestion && (sectionsInfoData.length <= currentTab.index + 1)) {
          console.log('----------------setting sqc-------------');
          localStorage.setItem("sqc", "true");
        }

        let screenName = currentQuestionnaireInfo.shortQuestion
          ? currentQuestionnaireInfo.shortQuestion?.toLowerCase().replace(/ /g, '_')
          : ((isRoomQuiz && profileData?.styleProfileID) ? "use_existing_styleprofile" : "")

        screenName && gtmPageOnloadTracking({
          event: (isRoomQuiz ? 'roomquiz_' : 'stylequiz_') + screenName + '_completed',
          pageType: isRoomQuiz ? "Room Questionnaire" : "Style Questionnaire",
          quizName: currentQuestionnaireInfo.shortQuestion,
          quizSeq: currentQuestionnaireInfo.questionSequence,
          shortQuestion: currentQuestionnaireInfo.shortQuestion,
          sq_selected_answers: selectedAnswer.map((option:ChoiceAnswer)=>{return option.answer}).join(","),
          sq_style_selected: "next"
        });
        saveCustResponseReturnnExtQuestionData({
          brand,
          "previousQuestionSequence": currentQuestionnaireInfo.previousQuestionSequence,
          "title": currentSection.title,
          //"NextQuestionSectionID": currentQuestionnaireInfo.nextSectionID,
          "NextQuestionSectionID": currentQuestionnaireInfo.firstQuestionNumber ? currentQuestionnaireInfo.nextSectionID : currentSection.sectionID,
          "SectionID": currentSection.sectionID,
          "NextQuestionSequence": currentQuestionnaireInfo.firstQuestionNumber || currentSection.sequences[currentQuestionnaireInfo.questionSequence],
          "CustomerID": profileData?.customerID,
          "customerType": customerType.replace(/[<>*]/g, ''),
          "shortQuestion": currentQuestionnaireInfo.shortQuestion,
          "questionID": withEmptyResponses ? "" : currentQuestionnaireInfo.questionID,
          ...getQuizFields(),
          "responses": withEmptyResponses ? [{answers:[]}] : [{ "answers": selectedAnswer }],env
        });

      }
    }
    if (!(sectionQuestion && sectionQuestion.isLastQuestion && (sectionsInfoData.length <= currentTab.index + 1))) {
      setSelectedAnswer([])
    }
  }

  useEffect(() => {
    let withEmptyResponses = true;
    //for initial request without responses to get first question
    //sectionQuestion=null will be for first question in next section - we will make call with quesion sequence as 0
    if ((Object.keys(allQuestionsData).length == 0 && sectionsInfoData.length > 0) ||
      (sectionsInfoData.length > 0 && sectionQuestion == null) || pickCurrentSectionDetailsToState) {
      if (sectionQuestion == null) {
        withEmptyResponses = false;
      }
      //if we want to post for first question call with answer we must have customerID
      if (!profileData?.customerID &&
        !isdefaultCustAndProjectIdCalTriggered.current) {
        isdefaultCustAndProjectIdCalTriggered.current = true;
        postProfileData({
          firstName: getLoggedInName() || "Default Customer",
          email: getLoggedInEmailAddress() || undefined, //guest user we dont pass email
          includeStyleProfile: true,
          brand
        }) as any;
      } else {
        saveAndMoveNext(withEmptyResponses)
      }
    }
  }, [sectionsInfoData, sectionQuestion, customerID])


  useEffect(() => {

    if (customerID &&
      currentQuestionnaireInfo.shortQuestion === "Room") {
      getCustomerRoomLabel({
        CustomerID: customerID,
        roomType: roomType
      })
    }
  }, [customerID, sectionQuestion])

  useEffect(() => {
    if (selectedAnswer &&
      customerID &&
      currentQuestionnaireInfo.shortQuestion === "Room" &&
      selectedAnswer[0]) {
      setRoomTypeFromQuestion(selectedAnswer[0].answer);
    }
  }, [selectedAnswer])

  useEffect(() => {
    if (customerID && !getLoggedInEmailAddress()) {
      setTempCustIdToLS(customerID);
    }
  }, [customerID])

  const containerRef = useRef<HTMLDivElement>(null)
  const [isFloating, setIsFloating] = useState<boolean>(true)
  const [isFirstStyleQuizScreen, setIsFirstStyleQuizScreen] = useState<boolean>(true);

  const isBottom = (el: HTMLElement) => {
      return el?.getBoundingClientRect().bottom <= window.innerHeight;
  }

  const trackScrolling = () => {
      const wrappedElement:any = document.getElementById('container');
      if (isBottom(wrappedElement)) {
        setIsFloating(false)
      } else {
        setIsFloating(true)
      }
  };

  useEffect(() => {
      document.addEventListener('scroll', trackScrolling)
      return () =>
          document.removeEventListener('scroll', trackScrolling);
  }, [trackScrolling]);

  const generateQuestion = (currentQuestionnaireInfo: any,) => {
    let placeHolder = "enter your room label";
    try {
      placeHolder = localStorage.getItem("roomq") || "enter your room label";
    } catch (e) { }
    let isRoomQuestion = false;
    if (currentQuestionnaireInfo.shortQuestion === "Room") {
      isRoomQuestion = false;
    }

    if (sectionQuestion) {
      const singleQuestion = sectionQuestion.NextQuestionAnswerChoices.questions[0];
      const description = sectionQuestion.NextQuestionAnswerChoices.description;
      const minSelections = singleQuestion.template.min_selections;
      navigatetoNextQuestion.current.isMinSelQuestion = parseInt(minSelections) > 0
      navigatetoNextQuestion.current.minSelections = minSelections;
      const questionData = getQuestionType(singleQuestion.template.type, sectionQuestion.NextQuestionAnswerChoices.questionID, singleQuestion.template);
      const shortQuestion = sectionQuestion.NextQuestionAnswerChoices.shortQuestion;
      isStyleQuizFirstScreen = (shortQuestion === "Primary Goals")
      return (<>
        {
          (roomType && roomType != 'null' && (decodeURIComponent(roomType).replace(/[<>*]/g, '')).length > 0 && isRoomQuestion) ?
            <></> : (<QuestionComponent
              title={singleQuestion.text}
              description={description}
              qlabel={singleQuestion.label}
              Element={questionData.Element}
              isMinSelQuestion={isMinSelQuestion}
              key={sectionQuestion.NextQuestionAnswerChoices.questionID}
              elementProps={{
                template: singleQuestion.template,
                props: questionData.props,
                editData: sectionQuestion.NextQuestionAnswerResponse,
                choices: sectionQuestion.questionColorChoices || singleQuestion.choices,
                selectedAnswer,
                setSelectedAnswer,
                minSelections,
                shortQuestion
              }}
            />)
        }
        {isRoomQuestion ?
          (<FuzzyDropdown
            setRoomLabel={setRoomLabel}
            customerID={customerID}
            roomLabel={roomLabel}
            roomType={roomTypeFromQuestion || roomType}
            customerRoomLabelResponse={customerRoomLabelResponse} />
          ) : <></>
        }
      </>
      )
    }
  }

  const loadQuestion = (currentQuestionnaireInfo: any) => {
    
    return (
      (sectionQuestion) ? (<div ref={containerRef} id={'container'}>{generateQuestion(currentQuestionnaireInfo)}<Paper sx={{ padding: '20px 30px' }} elevation={3} square>
        <footer className={`${cssStyles["project-goal-footer"]} ${isFloating ? cssStyles["sticky"]: ''}`}>
          {sectionQuestion.sectionID}
          {(customerID) && (<DTag as="a" className={cssStyles["back-link"]} href="javascript:void(0)" onClick={goPreviousQuestion}>
            <ArrowBackIosIcon />Back
          </DTag>)}

          {/* <Button className={cssStyles["save-and-exit-button"]} onClick={saveAndExit} sx={{
                                  backgroundColor: 'primary.light',
                                  '&:hover': {
                                      backgroundColor: 'primary.light' 
                                  },
                                  borderColor: 'primary.main'
                          }}>Save and Exit</Button>  */}

          <Button color={sectionQuestion && sectionQuestion.isLastQuestion && (sectionsInfoData.length <= currentTab.index + 1) ? 'primary' : 'success'} className={cssStyles["next-button"]} onClick={() => {
            saveAndMoveNext(false, true);
            handleNextButtonClick();
          }} >
            {sectionQuestion && sectionQuestion.isLastQuestion && (sectionsInfoData.length <= currentTab.index + 1) ? sectionQuestion.NextQuestionAnswerChoices.sectionType === 'RoomQuiz' ? "See Recommendations" : "See Your Style Profile" : "Next"}
          </Button>
        </footer>
      </Paper></div>) : (<div className={cssStyles["load-questions"]}><CircularProgress /></div>)
    )
  }

  const handleStyleSchemeSelection = (styleScheme: any) => {
    if (styleScheme.style == "help_me") { 
      setFromFirstFlow(false)
      gtmClickTracking({
        event: 'need_help_clicked',
        pageType: "Style Questionnaire",
        pageName: "Preheat Style Selector",
        pageTitle : "Preheat: Select your Style",
        brandName: brand,
        sq_style_selected: "help_me"
      });
      setShowDefaultCustomerStyleQuiz(true);
      window.scrollTo(0, 0);
      setSelectedStyleScheme("");
    } else {
      setSelectedStyleScheme(styleScheme.style);
    }
  }




  const [nextClicked, setNextClicked] = useState(false);
  const [welcomeTextExpanded, setWelcomeTextExpanded] = useState(false);
  const expandWelcomeText = () => {
    setWelcomeTextExpanded(true);
  }

    const handleNextButtonClick = async () => {
      setNextClicked(true); // Set clicked state
    
      try {
        const userInfo = await getUserInfo(); // Fetch user info
        console.log('User Info:', userInfo); // Debugging log
        if (userInfo) {
          await fetchStyleProfile(userInfo); // Call fetch with user info
        }
      } catch (error) {
        console.error('Error getting user info:', error);
      }
    };

    const fetchStyleProfile = async (userInfo : any) => {
        setLoading(true);
        console.log("Fetching style profile..."); // Log before the fetch call

        try {
            const response = await fetch('https://d221a61rb87vel.cloudfront.net/v1/api/customer/savecustomerprofile?includeStyleProfile=true', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                  {
                    firstName: "User",
                    email: userInfo.emailID || undefined ,
                    customerID: userInfo.cId,
                    includeStyleProfile: true,
                    brand: "nestingale",
                    selectedStyleProfileScheme: selectedStyleScheme,
                }
              //   {
              //     firstName: "User",
              //     email: null,
              //     customerID: "576b42b4-20a7-483c-b01b-61a390581f83",
              //     includeStyleProfile: true,
              //     brand: "nestingale",
              //     selectedStyleProfileScheme: "traditional"
              // }
              ),
            });
            const data = await response.json();
            console.log("-------------- Style quiz fetched customerID is ", data.customerID);

            // Check if the response is ok
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // const data = await response.json();
            console.log("Fetched data: ", data); // Log full response data

            // Update with fetched data
            setStyleVibeImage(data.styleVibeImage);
            setStyleProfileDescription(data.styleProfileDesc);
            console.log('Fetched description for style quiz: ', data.styleProfileDesc);
        } catch (error) {
            console.error('Error fetching style profile data:', error);
        } finally {
            setLoading(false); // Stop the loading state after fetching
        }
    };

    useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700); // Detect mobile screen
      // setisLargeDesk(window.innerWidth >= 1600); // Detect Large Desktop 1280px
    };

    handleResize(); // Check on component mount
    window.addEventListener("resize", handleResize); // Listen for window resize events

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
    };
}, [nextClicked, selectedStyleScheme]);

const [warningMessage, setWarningMessage] = useState("");
// this effect is used to move the user to the 3rd questionnaire screen(style quiz)
 useEffect(()=>{
  if(fromFirstFlow&&currentQuestionnaireInfo.questionSequence===2){
    saveAndMoveNext(true, true);
  }
  if(fromFirstFlow&&currentQuestionnaireInfo.questionSequence===3){
    setShowDefaultCustomerStyleQuiz(true)
  }
 },[currentQuestionnaireInfo,fromFirstFlow])
  if (isFirstStyleQuizScreen && !isRoomQuiz && !showDefaultCustomerStyleQuiz) {
    return (
      <Grid container justifyContent="center">
        <Grid item xs={12} md={12} lg={10}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box component="div" id="quesions-section">
                <Box component="div" className={cssStyles["questions-wrapper"]} sx={{ width: '100%' }}>
                  <Box component="div">
                    <h2>Your style profile will guide you to make the right choices for your dream home</h2>
                    <div>
                      <div style={{ padding: "15px", paddingLeft: '0px', fontSize: '20px' }}>What style is your dream home?</div>
                      <div className={cssStyles["responsive-three-column-grid"]} >
                        {
                          styleSchemesData && styleSchemesData.length > 0 ?
                            [...styleSchemesData, { style: "help_me", styleDisplayName: "Help me decide" }].map((styleScheme: any) => {
                              return (
                                <div key={styleScheme.style} className={`${styleScheme.style === "help_me" ? cssStyles.help_me : ''}`} style={{ width: "100%", minHeight: "190px", cursor: "pointer",  marginBottom: "10px" }} onClick={(e) => {
                                  handleStyleSchemeSelection(styleScheme);
                                  if (!getLoggedInEmailAddress()) {
                                    setSaveStyleSchemeSelectionForApiCall(true)
                                  }
                                }}>
                                  {
                                    (styleScheme.style != "help_me") ?
                                      (
                                        <div style={{textAlign:'center'}}>
                                        <Box component="img"  sx={{ boxShadow: `${styleScheme.style == selectedStyleScheme ? 5 : 0}`, maxWidth: "100%", height: "auto", borderWidth: `${styleScheme.style == selectedStyleScheme ? "3px" : "2px"}`, borderStyle: "solid", borderRadius: "15px", "borderColor": `${styleScheme.style == selectedStyleScheme ? "#0D908E" : "gray"}` }}
                                          src={styleScheme.styleImage}
                                          alt={styleScheme.styleDisplayName} />
                                        <div style={{ textAlign: "center" }}>{styleScheme.styleDisplayName}</div>
                                        </div>) :
                                      (<>
                                        <div className={cssStyles.question_symbol}>?</div>
                                        <div className={cssStyles.help_me_text} style={{ textAlign: "center" }}>{styleScheme.styleDisplayName}</div>
                                      </>)
                                  }

                                </div>
                              )
                            }) :  
                              <>
                              {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: '10px' }}> */}
                              {/* Map over an array of 16 to generate 16 skeletons */}
                              {Array.from({ length: 16 }).map((_, index) => (
                                <div key={index} style={{ marginBottom: '10px', width: '100%', minHeight: '190px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                  {/* Skeleton for Image */}
                                  <Skeleton variant="rounded" width={365} height={254} sx={{borderRadius:'14px'}} animation="wave" />
                                  {/* Skeleton for Text */}
                                  <Skeleton sx={{display:"flex", alignItems:'center', justifyContent:'center'}} variant="text" width={140} height={30} animation="wave" />
                                </div>
                              ))}
                            {/* </div> */}
                            </>
                            // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></div>

                        }
                      </div>

                    </div>

                    {/* Display warning message conditionally */}
                    {warningMessage && (
                      <div style={{
                        color: "red",
                        padding: "10px",
                        backgroundColor: "#fdd",
                        borderRadius: "4px",
                        marginBottom: "15px",
                        textAlign: "center",
                      }}>
                        {warningMessage}
                      </div>
                    )}
                    <div>

                      <Box component={'div'} className={cssStyles.help_me_next_btn} display='flex' alignItems='center' justifyContent='center'>
                      <Button color="success" onClick={async () => {

                          // Reset the warning message initially
                          setWarningMessage("");
                          //make api call to save with existing customerId
                          if (selectedStyleScheme) {
                            // Trigger the preheat_style_selector event when style is selected
                            // setNextClicked(true);
                            handleNextButtonClick();
                            gtmClickTracking({
                              event: "preheat_style_selector",
                              pageType: "Style Questionnaire",
                              pageName: "Preheat Style Selector",
                              pageTitle: "Preheat: Select your Style",
                              brandName: brand,
                              sq_style_selected: selectedStyleScheme
                            });
                            setFromFirstFlow(true)
                            saveAndMoveNext(true, true);
                            // if (!getLoggedInEmailAddress()) {
                            //   openLoginLayer();
                            //   gtmPageOnloadTracking({
                            //     event: 'sign_in_after_selection',
                            //     pageType: "Sign In Page",
                            //     pageName: "Sign In to save your style profile",
                            //     title: "Style Profile Sign In",
                            //     sq_style_selected: selectedStyleScheme
                            //   })
                            // }else{
                            //   (async function () {
        
                            //     gtmPageOnloadTracking({
                            //       event: 'Style Selected',
                            //       pageType: "Style Questionnaire",
                            //       pageName: "Style Selector",
                            //       title : "Select your Style",
                            //       sq_style_selected: selectedStyleScheme
                            //     });
                        
                            //     await getUserInfo("",
                            //       true,
                            //       false,
                            //       selectedStyleScheme);
                        
                            //     navigateWithHistory(navigate, `${getCurrentBrand()}/styleprofile`)
                            //   })();
                            // }
                          } else {
                            // Set the warning message if style scheme is not selected
                            setWarningMessage("Please select StyleScheme");
                          }

                          //Navigate to another page form here
                          //navigateWithHistory(navigate, "/rooms");
                        }} sx={{ m: 4, width: '200px' }}>{fromFirstFlow?'Loading...':'Next'}</Button>
                      </Box>
                    </div>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {openLogin && (
          <>
            <Box component="div" className={cssStyles.style_profile_bg_wrapper} sx={{
              backgroundImage: `url(${styleVibeImage})`,
              backgroundSize: "contain", // Ensure image fits properly
              backgroundPosition: "center",
              width: "100%",
              minHeight: "100vh",
              height: "auto",
              // maxWidth: "100%",
              // height: { xs: "50vh", md: "auto" }, // Restrict height on mobile, auto on larger screens
              position: "relative", // Ensure it's relative to handle positioning for mobile
              filter: 'blur(5px)'
            }}
            >
              <Box component="div" className={cssStyles.style_profile_heading}>
                <h1>Welcome to your style profile!</h1>
                {/* <h2 dangerouslySetInnerHTML={{ __html: styleProfileDesc }} /> Render HTML safely */}
                {<h2 onClick={expandWelcomeText} className={`${cssStyles["h2"]} ${welcomeTextExpanded ? cssStyles["expanded"] : ''}`} dangerouslySetInnerHTML={{ __html: styleProfileDesc }}>
                </h2>}
              </Box>
              <Box component="div" className={cssStyles.select_design_section}>
                <h2>{`Now, let's start designing!`}</h2>
                <Box component={'div'} display='flex' alignItems='center' justifyContent='center'>
                  <Button color="success" sx={{ width: '300px', border: 'none' }}>Select your room</Button>
                </Box>
              </Box>
              <Layer
                open={openLogin}
                onClose={closeLoginLayer}
                Element={() => <LoginLayer
                  layerMode={true}
                  brand={brand}
                  loginCallback={loginCallback}
                  setHideLayerTitle={setHideLayerTitle}
                  hideLayerTitle={hideLayerTitle}
                  isStyleQquiz={sectionQuestion?.NextQuestionAnswerChoices?.sectionType != 'RoomQuiz' && (!getLoggedInEmailAddress() || !getCustStyleProfileIdFromLS())} />}
                dialogContentClassName={''}
                hideLayerTitle={hideLayerTitle}
                isStyleQquiz={sectionQuestion?.NextQuestionAnswerChoices?.sectionType != 'RoomQuiz' && (!getLoggedInEmailAddress() || !getCustStyleProfileIdFromLS())}
                dialogContentComponentProps={{
                  heading: 'Login'
                }}
                dialogTitle={'Almost done, Sign up to view your design identity'} />

                {/* Mobile View: Bottom half image for roomsView */}
                {isMobile ? 
                (<img className='rooms-view-container' src='assets/img/roomsView.png' alt='roomsViewImage' 
                style={{position: 'absolute',
                    bottom: 0, 
                    zIndex: 1,
                    marginTop: '20px',
                    height: '40vh',
                    width: '100%',
                    filter: 'blur(5px)'}}
                    />) : (<img className='rooms-view-container' src='assets/img/desktopView.png' alt='desktopViewImage' 
                      style={{position: 'absolute',
                          bottom: 0, 
                          zIndex: 1,
                          marginTop: '20px',
                          height: '40vh',
                          width: '100%',
                          filter: 'blur(5px)'}}
                          />)}
              </Box>
          </>)
        }
      </Grid>)
  }


  return (
    <>
     
      {!isProfileLoaded ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></div>
        :
        <>
          {askToUseExistingStyleProfile ?
            <Grid container justifyContent="center">
              <Grid item xs={12} md={12} lg={10}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box component="div" id="quesions-section">                      
                      <Box component="div" className={cssStyles["questions-wrapper"]} sx={{ width: '100%' }}>
                        <Paper sx={{ padding: '20px 30px' }} elevation={3} square>
                          <h1 style={{
                            textAlign: "center",
                            marginBottom: '20px',
                            lineHeight: '24px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            fontSize: '20px'
                          }}>Looks like you&apos;ve completed our Style Quiz before. Would you like to apply this style vibe to your room?</h1>
                          <Box component="div" id="tab-panel" className={cssStyles["design-question-panel"]}>
                            {profileData.styleVibeImage &&
                              <div style={{ width: "100%", maxWidth: "100%", maxHeight: "100%", display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                <img src={profileData.styleVibeImage} alt="ProfileStyleVibeImage" style={{ width: '100%', borderRadius: '15px' }} />
                              </div>
                            }
                          </Box>
                        </Paper>
                        <Paper sx={{ padding: '0px 10px', marginBottom: '10px' }} elevation={3} square>
                          <Box component={'div'} display='flex' alignItems='center' justifyContent='center'>
                            <Button color="success" onClick={() => { setUseExistingStyleProfile(true); setAskToUseExistingStyleProfile(false); }} sx={{ m: 2 }}>Yes</Button>
                            <Button color="info" onClick={() => { setUseExistingStyleProfile(false); setAskToUseExistingStyleProfile(false); }}>NO</Button>
                          </Box>
                        </Paper>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>






            :

            (sectionsInfoData && sectionsInfoData.length > 0 ?
              <>
                <Grid container justifyContent="center">
                  <Grid item xs={12} md={12} lg={10}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>

                        <Box component="div" id="quesions-section">
                          <div style={{ "display": `${deviceTypeModel === "Mobile" ? "flex" : "none"}`, "justifyContent": "center" }}>
                            <DTag as="a" className={cssStyles["back-link"]} href="javascript:void(0)" onClick={goPreviousQuestion}>
                              <ArrowBackIosIcon style={{ height: "1em", "display": `${currentQuestionnaireInfo.previousQuestionSequence == 0 ? "none" : "inline-block"}` }} />
                            </DTag>
                            <div style={{ lineHeight: "1.25em", fontSize: "16px" }} className={tabStyles["tab-index"]}>{currentQuestionnaireInfo.previousQuestionSequence + 1} of {sectionsInfoData[currentTab.index].count}</div>
                            <DTag as="a" className={cssStyles["back-link"]} href="javascript:void(0)" onClick={() => saveAndMoveNext(false, true)} >
                              <ArrowForwardIosIcon style={{ height: "1em" }} />
                            </DTag>
                          </div>
                          <Box component="div" className={cssStyles["questions-wrapper"]} sx={{ width: '100%' }}>
                            <Box component="div">
                              <div className={tabStyles["label"]}>
                                {/* {sectionsInfoData && sectionsInfoData[currentTab.index]?.title} */}
                                {sectionsInfoData && sectionsInfoData.length !== (currentTab.index + 1) && <span>Next: {sectionsInfoData[currentTab.index + 1]?.title}</span>}
                              </div>
                            </Box>
                            <Tabs variant="fullWidth" value={currentTab.index} aria-label="basic tabs example" className={tabStyles.tabContainer}>
                              {
                                sectionsInfoData && sectionsInfoData.map((eachSection: any, index: number) => {
                                  return eachSection.title && (eachSection.title.indexOf("DefaultCustomer") == -1 && eachSection.title.indexOf("RoomQuiz") == -1) ?
                                    (
                                      <Tab
                                        key={index}
                                        sx={{
                                          '&:before': {
                                            borderTopColor: currentTab.index >= index ? 'primary.main' : 'secondary.light'
                                          }
                                        }}
                                        label={<>
                                          {currentTab.index > index ? (
                                            <CheckCircleOutlineIcon sx={{ color: 'primary.main', fontSize: '24px' }} />
                                          ) : (
                                            <Box component="div" className={tabStyles["tab-icon"]}
                                              sx={{
                                                borderColor: currentTab.index == index ? 'primary.main' : 'secondary.dark'
                                              }}>
                                              <Box component="div" className={tabStyles["half-circle"]}
                                                sx={{
                                                  backgroundColor: currentTab.index == index ? 'primary.main' : 'transparent'
                                                }}
                                              ></Box>
                                            </Box>
                                          )}
                                          <span>{eachSection.title}</span>
                                        </>}
                                        {...a11yProps(index)}
                                      />
                                    ) : (
                                      <div className={cssStyles['current-question-indicator']}>
                                        {
                                          QuestionIndicator(sectionsInfoData, currentTab, currentQuestionnaireInfo,fromFirstFlow)
                                        }
                                      </div>
                                    )
                                })
                              }
                            </Tabs>
                            <TabPanel value={currentTab.index} index={currentTab.index}>
                              {/* {
                      <div className='current-question-indicator'> 
                        {
                          QuestionIndicator(sectionsInfoData, currentTab, currentQuestionnaireInfo) 
                        }
                      </div>
                      } */}
                              <Box component="div" id="tab-panel" className={cssStyles["design-question-panel"]}>
                                {showError && <Alert severity="error">Please select atleast one choice</Alert>}


                                {loadQuestion(currentQuestionnaireInfo)}
                              </Box>
                              {/* <div className='current-question-indicator'> 
                        {
                          QuestionIndicator(sectionsInfoData, currentTab, currentQuestionnaireInfo)
                        }
                      </div> */}
                            </TabPanel>

                            {sectionQuestion && sectionQuestion.isLastQuestion && isNextButtonClicked.current && (sectionsInfoData.length > currentTab.index + 1) ?
                              <PopUpComponent {...{
                                heading: `${getTextForNumbers(currentTab.index + 1)} down, ${getTextForNumbers(sectionsInfoData.length - (currentTab.index + 1))} more to go!`,
                                text: `Now that we now some details about ${sectionsInfoData[currentTab.index].title} of the room, lets discuss your ${sectionsInfoData[currentTab.index + 1].title}`,
                                saveAndExit,
                                value: document.getElementById("quesions-section"),
                                saveAndMoveNext
                              }} /> : ""}
                          </Box>

                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid> </> : <CircularProgress sx={{ color: 'secondary.main', opacity: '0.3' }} size="60" />
            )
          }



        </>
      }
      {
        openLogin && (
          <>
            <Box component="div" className={cssStyles.style_profile_bg_wrapper} sx={{
              backgroundImage: `url(${styleVibeImage})`,
              backgroundSize: "contain", // Ensure image fits properly
              backgroundPosition: "center",
              width: "100%",
              minHeight: "100vh",
              height: "auto",
              // maxWidth: "100%",
              // height: { xs: "50vh", md: "auto" }, // Restrict height on mobile, auto on larger screens
              position: "relative", // Ensure it's relative to handle positioning for mobile
              filter: 'blur(5px)'
            }}
            >
              <Box component="div" className={cssStyles.style_profile_heading}>
                <h1>Welcome to your style profile!</h1>
                {/* <h2 dangerouslySetInnerHTML={{ __html: styleProfileDesc }} /> Render HTML safely */}
                {<h2 onClick={expandWelcomeText} className={`${cssStyles["h2"]} ${welcomeTextExpanded ? cssStyles["expanded"] : ''}`} dangerouslySetInnerHTML={{ __html: styleProfileDesc }}>
                </h2>}
              </Box>
              <Box component="div" className={cssStyles.select_design_section}>
                <h2>{`Now, let's start designing!`}</h2>
                <Box component={'div'} display='flex' alignItems='center' justifyContent='center'>
                  <Button color="success" sx={{ width: '300px', border: 'none' }}>Select your room</Button>
                </Box>
              </Box>
              <Layer
                open={openLogin}
                onClose={closeLoginLayer}
                noBackdrop={true}
                Element={() => <LoginLayer
                  layerMode={true}
                  brand={brand}
                  loginCallback={loginCallback}
                  setHideLayerTitle={setHideLayerTitle}
                  hideLayerTitle={hideLayerTitle}
                  isStyleQquiz={sectionQuestion?.NextQuestionAnswerChoices?.sectionType != 'RoomQuiz' && (!getLoggedInEmailAddress() || !getCustStyleProfileIdFromLS())} />}
                dialogContentClassName={''}
                hideLayerTitle={hideLayerTitle}
                isStyleQquiz={sectionQuestion?.NextQuestionAnswerChoices?.sectionType != 'RoomQuiz' && (!getLoggedInEmailAddress() || !getCustStyleProfileIdFromLS())}
                dialogContentComponentProps={{
                  heading: 'Login'
                }}
                dialogTitle={'Almost done, Sign up to view your design identity'} />

                {/* Mobile View: Bottom half image for roomsView */}
                {isMobile ? (<img className='rooms-view-container' src='assets/img/roomsView.png' alt='roomsViewImage' 
                style={{position: 'absolute',
                    bottom: 0, 
                    zIndex: 1,
                    marginTop: '20px',
                    height: '40vh',
                    width: '100%',
                    filter: 'blur(5px)'}}
                    />) : (<img className='rooms-view-container' src='assets/img/desktopView.png' alt='desktopViewImage' 
                      style={{position: 'absolute',
                          bottom: 0, 
                          zIndex: 1,
                          marginTop: '20px',
                          height: '40vh',
                          width: '100%',
                          filter: 'blur(5px)'}}
                          />)}
              </Box>
          </>
        )
      }

    </>
  );
}

export default ClientComponent(React.memo(BasicTabs));




